module.exports = __webpack_public_path__ + "img/product_1.23f1c79.webp";